import { render, staticRenderFns } from "./NoLongerTakingEnquiries.vue?vue&type=template&id=37c83104&"
import script from "./NoLongerTakingEnquiries.vue?vue&type=script&lang=js&"
export * from "./NoLongerTakingEnquiries.vue?vue&type=script&lang=js&"
import style0 from "./NoLongerTakingEnquiries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports